import MeditationsRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/MeditationService/MeditationsRequest";
import SearchRequest from "@/api/dataSource/api/Spirit/Common/Extensions/Models/SearchRequest";
import IFilterModel from "../IFilterModel";
import moment from "moment";



export default class MeditationFilterModel implements IFilterModel {
    search: string = '';
    categoryId: number = null;
    dateFrom: Date = null;
    dateTo: Date = null;
    isPaid: boolean = null;
    isSleep: boolean = null;
    resetToDefault() {
        this.search = '';
        this.categoryId = null;
        this.dateFrom = null;
        this.dateTo = null;
        this.isPaid = null;
        this.isSleep = null;
    }
    toSearchRequest(): SearchRequest[] {
        const res = new Array<SearchRequest>();
        // this.search && res.push(new SearchRequest({FieldName: 'Search', SearchValue: this.search}));
        // this.categoryId && res.push(new SearchRequest({FieldName: 'CategoryId', SearchValue: this.categoryId.toString()}));
        if (this.dateFrom) {
        const range = new SearchRequest({FieldName: 'Created', SearchFrom: moment(this.dateFrom).format('YYYY-MM-DD')});
            res.push(range);
            if (this.dateTo) {
                range.SearchTo = moment(this.dateTo).format('YYYY-MM-DD');
            }
        }
        this.isPaid != null && res.push(new SearchRequest({FieldName: 'IsPaid', SearchValue: this.isPaid.toString()}));
        this.isSleep != null && res.push(new SearchRequest({FieldName: 'IsSleep', SearchValue: this.isSleep.toString()}));
        return res;
    }
    toFilterRequest(): MeditationsRequest {
        const res = new MeditationsRequest({
            CategoryId: this.categoryId,
            Name: this.search
        });
        res.Search = this.toSearchRequest();
        return res;
    }
}